import CitiesShowcase from './CitiesShowcase';

export default CitiesShowcase;
